import React from "react";
import "../styles/Section1.scss";

const Section1 = () => {
  return (
    <section className="section-hero" id="sectionStart">
      {/* Video de fondo */}
      <video autoPlay muted loop playsInline className="hero-video">
        <source src="https://ovitsolucionesweb.com/ovit.mp4" type="video/mp4" />
        Tu navegador no soporta el video.
      </video>

      {/* Overlays */}
      <div className="hero-overlay" aria-hidden="true" />
      <div className="hero-grid" aria-hidden="true" />
      <div className="hero-glow hero-glow--1" aria-hidden="true" />
      <div className="hero-glow hero-glow--2" aria-hidden="true" />

      {/* Contenido */}
      <div className="hero-content">
        <div className="hero-kicker">
          <span className="hero-dot" aria-hidden="true" />
          <span>Estrategia Digital Completa</span>
        </div>

        <h1 className="hero-title">
          Resultados reales <br />
          <span className="highlight1">en tiempo récord.</span>
        </h1>

        <p className="hero-subtitle">
          Convertimos tu presencia digital en un sistema que atrae prospectos, responde rápido y
          convierte ventas con contenido, campañas y automatización.
        </p>

        <div className="hero-actions">
          <a href="#nosotrosH" className="hero-button">
            Invierte en tu crecimiento
          </a>

          <a href="#ovit-services" className="hero-button hero-button--ghost">
            Ver servicios
          </a>
        </div>

        <div className="hero-scrollHint" aria-hidden="true">
          <span className="hero-scrollDot" />
          <span>Desliza para ver más</span>
        </div>
      </div>
    </section>
  );
};

export default Section1;
